import store from '../store/index';

export default {
  GetFirstName() {
    console.log('Inside GetFirstName of NewBooking');
    console.log(store.getters['userInfo/firstName']);
  },
  GetLastName() {
    console.log('Inside GetLastName of NewBooking');
    console.log(store.getters['userInfo/lastName']);
  },
  GetDateOfBirth() {
    console.log('Inside GetDateOfBirth of NewBooking');
    console.log(store.getters['userInfo/dateOfBirth']);
  },
  GetBeginDate() {
    console.log('Inside GetBeginDate of NewBooking');
    console.log(store.getters.beginDate);
  },
  GetEndDate() {
    console.log('Inside GetEndDate of NewBooking');
    console.log(store.getters.endDate);
  },
  GetResponseID() {
    console.log('Inside GetResponseID of NewBooking');
    console.log(store.getters.responseID);
  },
};
